/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putPreferences.defs.js'
export { main as default } from './putPreferences.defs.js'
